import { render, staticRenderFns } from "./message-counter.vue?vue&type=template&id=567dcdf4&scoped=true"
import script from "./message-counter.vue?vue&type=script&lang=js"
export * from "./message-counter.vue?vue&type=script&lang=js"
import style0 from "./message-counter.vue?vue&type=style&index=0&id=567dcdf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567dcdf4",
  null
  
)

export default component.exports